export default __webpack_public_path__ + "static/course5-918ff8747fd947e95065b27e05184b39.jpg";